"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _cosmicReactResizeHook = require("@designbycosmic/cosmic-react-resize-hook");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/**
 * ModalBody wraps the `children` passed to Modal and applies some styling
 * to allow content that overflows the height of the viewport
 *
 */


var ModalBody = function ModalBody(_ref) {
  var children = _ref.children,
      Close = _ref.Close,
      fullScreen = _ref.fullScreen;
  var el = (0, _react.useRef)();

  var _useWindowSize = (0, _cosmicReactResizeHook.useWindowSize)(),
      innerHeight = _useWindowSize.innerHeight;

  var width = fullScreen ? "100%" : "auto";
  return _react.default.createElement("div", {
    ref: el,
    className: "ModalBody relative",
    style: {
      width: width,
      zIndex: 1
    }
  }, _react.default.createElement(Close, null), _react.default.createElement("div", {
    style: {
      maxHeight: innerHeight,
      height: fullScreen ? innerHeight : undefined,
      overflow: "auto"
    }
  }, children));
};

ModalBody.propTypes = {
  children: _propTypes.default.node.isRequired,
  Close: _propTypes.default.func.isRequired,
  fullScreen: _propTypes.default.bool.isRequired
};
var _default = ModalBody;
exports.default = _default;